import { Directive, Input, ElementRef, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { JoyrideService, JoyrideStep } from './joyride.service';
  
@Directive({
    selector: '[joyrideStep]'
})
export class JoyrideStepDirective implements OnInit, OnDestroy {
  
    @Input('joyrideStep')
    step: JoyrideStep;

    @Output() next = new EventEmitter();
    @Output() done = new EventEmitter();

    doneSubscription;
    nextSubscription;
  
    constructor(private elementRef: ElementRef, private joyride: JoyrideService) { 
        this.doneSubscription = this.joyride.events.done.subscribe(step => {
            this.emitEvent('done', step);
        });
        this.nextSubscription = this.joyride.events.next.subscribe(step => {
            this.emitEvent('next', step);
        });
    }
    emitEvent(eventName, value) {
        const step = this.step;
        if( !step || !value ) {
            return;
        }
        const steps = Array.isArray(step) ? step : [step];
        for(var i = 0; i < steps.length; i++) {
            const item = steps[i];
            if( item.name == value.name ) {
                this[eventName].emit(value);
            }
        }
    }
    ngOnInit() {
        const step = this.step;
        if( !step ) {
            return;
        }
        this.joyride.setStep(this.step, this.elementRef);
    }
    ngOnDestroy() {
        this.joyride.removeStep(this.step);
        if( this.doneSubscription ) {
            this.doneSubscription.unsubscribe();
        }
        if( this.nextSubscription ) {
            this.nextSubscription.unsubscribe();
        }
    }
}